<template>
    <div class="container-fluid" ref="container">
        <div class="container-fluid" v-if="loaded">
            <kibana
              :dimensions="kibanaDimensions"
              :dateRange="getDateRange"
              :session="session"
              :kibanaToken="kibanaToken"
              :kibanaLocation="kibanaLocation"
              :dashboard="convDashboard"
            >
            </kibana>
        </div>
    </div>
</template>

<script type="text/babel">
import Kibana from '../../../components/Panel/Analytics/Kibana.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'AnalyticsConvView',
    data () {
        return {
            kibanaDimensions: null,
            loaded: false,
            convDashboard: 'AWkKH2nA1vhUCTncj8b6'
        };
    },
    methods: {
        handleResize(){
            let {container} = this.$refs;
            let {width} = container.getBoundingClientRect();
            let height = window.innerHeight;
            this.kibanaDimensions = { width, height};
        }
    },
    components: {
        Kibana
    },
    computed: {
      ...mapGetters({
        kibanaToken: 'getKibanaToken',
        getDateRange: 'getDateRange',
        session: 'getSession',
        kibanaLocation: 'getKibanaLocation'
      }),
    },
    mounted () {
        let {container} = this.$refs;
        let {width} = container.getBoundingClientRect();
        let height = window.innerHeight;
        this.width = window.innerWidth;
        this.kibanaDimensions = {width, height};
        this.loaded = true;
    },
    created () {
      if(!this.session || this.session === ''){
        this.$router.push({ name: 'analytics-select' })
      }
      window.addEventListener('resize', this.handleResize);
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize);
    },
};

</script>

<style lang="scss" scoped>
  .container-fluid{
    width: 100%;
    height: 100%;
  }

</style>
